import { generateRandomPassword, shuffleArray } from './HelperFunctions'
import { useAxios } from './Requests/useAxios'

export const Hooks = { useAxios }

export const HelperFuncs = { generateRandomPassword, shuffleArray }
